<template>
  <div class="comp-wrapper">
    <div class="comp-main">
      <van-checkbox-group v-model="bankIds">
        <van-cell-group>
          <van-cell v-for="(item, index) in questionBanks"
                    clickable
                    :key="item.id"
                    @click="handleToggleCheckbox(index)">
            <template #title>
              <span>{{item.bankName}}</span>
            </template>
            <template #right-icon>
              <van-checkbox :name="item.id"
                            shape="square"
                            ref="checkboxes" />
            </template>
          </van-cell>
        </van-cell-group>
      </van-checkbox-group>
    </div>
    <div class="comp-btn-box">
      <van-button @click="handleSelectAll">全部选中</van-button>
      <van-button @click="handleSelectNone">全部不选</van-button>
      <van-button type="info"
                  @click="handleSubmit">开始练习</van-button>
    </div>
  </div>
</template>

<script>
import store from '@/store'
export default {
  name: 'SelectQuestionBank',
  props: {
    dialogParams: {
      type: Object,
      default: () => ({})
    }
  },
  data() {
    return {
      questionBanks: [],
      bankIds: []
    }
  },
  mounted() {
    this.initData()
  },
  created() {
    window.addEventListener('popstate', this.handleBack)
  },
   beforeDestroy() {
    window.removeEventListener('popstate', this.handleBack)
  },
  methods: {
    handleBack(){
      this.handleClose()
    },
    initData() {
      const { questionBanks } = store.getters
      this.questionBanks = [...questionBanks]
      this.$nextTick(() => {
        this.handleSelectAll()
      })
    },
    handleToggleCheckbox(index) {
      this.$refs.checkboxes[index].toggle();
    },
    // 全选
    handleSelectAll() {
      this.$refs.checkboxes.forEach(item => {
        item.toggle(true)
      })
    },
    // 全不选
    handleSelectNone() {
      this.bankIds = []
      this.$refs.checkboxes.forEach(item => {
        item.toggle(false)
      })
    },
    handleSubmit() {
      this.$emit('confirm', { bankIds: [...this.bankIds] });
    },
    handleClose() {
      this.$emit('close', { close: '关闭传参' });
    }
  },
}
</script>

<style lang="less" scoped>
.comp-wrapper {
  position: relative;
  width: 100%;
  height: 100%;
  padding: 10px;
  box-sizing: border-box;
}
.comp-main {
  height: calc(100% - 56px);
  overflow-y: auto;
  overflow-x: hidden;
}
.comp-btn-box {
  display: flex;
  align-items: center;
  justify-content: center;
  position: absolute;
  left: 0;
  bottom: 0;
  width: 100%;
  height: 56px;
  background-color: #fff;
  border-top: 1px solid #eee;
  z-index: 10;
  .van-button {
    margin-left: 20px;
    &:first-child {
      margin-left: 0;
    }
  }
}
</style>